var _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTumblr = function SvgTumblr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 310 310",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "tumblr_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3 0 0 1.3 91 52)",
    d: "M63.6 159.3c-24 0-41.8-12.3-41.8-41.8V70.3H0V44.7C24 38.5 34 17.9 35.1 0H60v40.6h29v29.7H60v41.1c0 12.3 6.2 16.6 16.1 16.6h14.1v31.3H63.6z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    rx: 70,
    ry: 70,
    width: "100%",
    height: "100%",
    fill: "#fff",
    mask: "url(#tumblr_svg__a)"
  })));
};
export { SvgTumblr as ReactComponent };
export default "data:image/svg+xml,%3csvg viewBox='0 0 310 310' xmlns='http://www.w3.org/2000/svg'%3e %3cdefs%3e %3cmask id='logo-mask'%3e %3crect x='0' y='0' width='100%25' height='100%25' fill='white' /%3e %3cpath transform='scale(1.3), translate(70,40)' d='M63.6,159.3c-24,0-41.8-12.3-41.8-41.8V70.3H0V44.7C24,38.5,34,17.9,35.1,0H60v40.6h29v29.7H60v41.1 c0,12.3,6.2,16.6,16.1,16.6h14.1v31.3H63.6z'/%3e %3c/mask%3e %3c/defs%3e %3crect x='0' y='0' rx='70' ry='70' width='100%25' height='100%25' fill='white' mask='url(%23logo-mask)' /%3e %3c/svg%3e";